import { useEffect } from 'react';
import { Navigate, Outlet, useLocation } from 'react-router-dom';
import { useShallow } from 'zustand/react/shallow';

import { FullPageSpinner } from '@/components/FullPageSpinner';

import { useAuthStore } from '../../stores/useAuthStore';

/**
 * Route guard。
 *
 * 開場狀態是 `unknown`：這時候還不知道有沒有登入（refresh cookie 要打一趟 API 才知道），
 * 直接導去 /login 的話，重新整理就會閃一下登入頁再跳回來。所以先顯示 loading，
 * 等 bootstrap 有結果再決定。
 */
export function RequireAuth() {
  const location = useLocation();
  const { status, bootstrap } = useAuthStore(
    useShallow((state) => ({ status: state.status, bootstrap: state.bootstrap })),
  );

  useEffect(() => {
    if (status === 'unknown') {
      // bootstrap 內部有去重，StrictMode 的重複執行不會打出第二次 refresh
      void bootstrap();
    }
  }, [status, bootstrap]);

  if (status === 'unknown') {
    return <FullPageSpinner />;
  }

  if (status === 'anonymous') {
    // 記住原本要去的頁面，登入後直接回去
    return <Navigate to="/login" replace state={{ from: location.pathname }} />;
  }

  return <Outlet />;
}
